module.exports = __webpack_public_path__ + "static/media/menu2.882837ba.jpg";